import {
    $, addAction, addFilter, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    if ($('body').hasClass('header-transparent-background')) {
        addFilter('css-vars/register', (styles) => ({ ...styles, 'header-height': '0px' }));
    }
});
